import {
  HsaQuestion,
  HsaQuestionType,
  MULTI_SELECT_NONE_OPTION_VALUE,
  SINGLE_SELECT_OTHER_OPTION_VALUE,
} from "@redotech/redo-conversion-hsa-common/hsa-question-type";
import { DeepPartial } from "@redotech/util/type";

export type HsaOptionAnnotation = "Write-in" | "Exclusive";

/**
 * Behavior an option carries beyond its label (a write-in may be labeled "Yes";
 * a plain radio may offer "Other" with no text box), keyed by pool conventions.
 */
export function hsaOptionAnnotation(
  question: DeepPartial<HsaQuestion> | undefined,
  optionValue: string | undefined,
): HsaOptionAnnotation | undefined {
  if (
    question?.type === HsaQuestionType.SINGLE_SELECT_OTHER_QUESTION &&
    optionValue === SINGLE_SELECT_OTHER_OPTION_VALUE
  ) {
    return "Write-in";
  }
  if (
    question?.type === HsaQuestionType.MULTI_SELECT_NONE_QUESTION &&
    optionValue === MULTI_SELECT_NONE_OPTION_VALUE
  ) {
    return "Exclusive";
  }
  return undefined;
}
